import has from 'lodash/has';

import { isKZContextPage, isMonoAppRefPage, isSpecialRoutesPage, isWhiteLabelDeniedPage } from '@src/utils/routing';

import { getCRMSpecialHeaderText } from './getCRMSpecialHeaderText';

const SPECIAL_PAGE_HEADING = 'Займы онлайн от лучших МФО';
const KZ_CONTEXT_PAGE_HEADING = 'Займы в Казахстане';

export const getHeadingByRoute = (route: string, query: Record<string, string | string[]>) => {
  const isSpecial = isSpecialRoutesPage(route) || isWhiteLabelDeniedPage(route);
  const isCRMSpecial = isSpecial && has(query, 'landing_type');
  const isKZContext = isKZContextPage(route);
  const isMfoMonoRef = isMonoAppRefPage(route);

  if (isKZContext) {
    return { heading: KZ_CONTEXT_PAGE_HEADING, subHeading: '' };
  }

  if (isCRMSpecial) {
    return getCRMSpecialHeaderText(query?.landing_type as string);
  }

  if (isSpecial || isMfoMonoRef) {
    return {
      heading: SPECIAL_PAGE_HEADING,
      subHeading: '',
    };
  }
};
